module.exports = __webpack_public_path__ + "static/img/news-banner.b25a273.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newsCenter/news-banner.png
// module id = al1l
// module chunks = 44